export const gradeList = ['kids', 'adult'];